import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormattedMessage } from 'react-intl'

import { HouseNightlyTripIndividualDto } from '../../../../../../../../../../lib/graphql'
import { ControlledTextField } from '../../../../../../../../../forms'
import { formatMoney } from '../../../../../../../shared/utils/format/format-money/format-money'
import { HouseNightlyTripIndividualFieldProps } from '../../../form-container/HouseNightlyTripIndividualFormContainer'

export const HouseNightlyTripIndividualTouristTaxField = ({
  control,
  currencyArea,
  isFieldDisabled,
}: HouseNightlyTripIndividualFieldProps) => {
  const fieldProps = {
    disabled: isFieldDisabled,
    control,
    type: 'number',
    inline: true,
    rules: {},
    placeholder: formatMoney({ value: 0, currency: currencyArea.currency }),
  }

  const { setValue } = useFormContext<HouseNightlyTripIndividualDto>()

  return (
    <ControlledTextField
      {...fieldProps}
      name='options.touristTaxPrice'
      formatValue={(value) =>
        formatMoney({ value, currency: currencyArea.currency })
      }
      onReset={() =>
        setValue('options.touristTaxPrice', null, { shouldDirty: true })
      }
      label={
        <FormattedMessage
          id='ui.HouseOptionsTax.touristTax'
          defaultMessage='Montant de la taxe de séjour par nuit et par personne'
        />
      }
    />
  )
}
